export default {
  'common.ReLogin': 'ReLogin',
  'common.ChangePassword': 'Change password',
  'common.Logout': 'Log out',
  'common.LoginStatusInvalid': 'Login status is invalid, please log in again!',
  'common.BackHome': 'Back home',
  'message.HTTP_403': 'Sorry, you are not authorized to access this page.',
  'message.HTTP_404': 'Sorry, the page you visited does not exist.',

  '+FDO1E': 'Settled contact email',
  '/XxWUC': 'Note: Fill in self-owned overseas warehouse for self-owned overseas warehouse. If you dont have a service provider, please fill in "No"',
  '/q5fD8': 'Whether there is an overseas warehouse in the UK/Southeast Asia',
  '01n1lw': 'Does the brand already own the R trademark in Germany',
  '0sn8j/': 'Your name',
  '1wOLiI': 'Intention to be do an independent station',
  '2cyTCk': 'Submitted (waiting for {day1} working days) ——> After the screening has passed, it has been submitted to the platform synchronously (need to wait {day2} working days) ——> platform through',
  '2towDA': 'US station sales in the past year(USD)',
  '387HdI': 'Whether own or not own self-built overseas warehouse or third partys overseas warehouse',
  '3K1yMY': '库内监控材料',
  '49iOzF': 'Type of enterprise/brand',
  '4L3xFT': 'Company scale (number of staff)',
  '5grmob': 'Email address',
  '5rJPKe': 'The websites of countries that wish to open ManoMano',
  '6C4ze5': 'Main products category: single choice',
  '6jglbI': 'Place of registration for brand trademarks',
  '6nYN2s': 'Whether own or not own self-built overseas warehouse or third partys overseas warehouse',
  '6udigR': 'Nature of the company',
  '7V8auA': 'Sales of a single brand in omni-channels for nearly one year(USD)',
  '7gK7Rj': 'Average monthly sales of active stores in the last quarter(USD)',
  '7wp+GP': 'Sales of a single account on a single site of other e-commerce platforms in the past year',
  '85GJe2': 'Phone number of the person who is in charge of the account',
  '8xAjhV': 'Contact information of sellers',
  '9aEF/T': 'Supply of goods for shops',
  '9bKiBE': 'Note: Please make sure that the email address can receive email, so you can receive the registration link.',
  'A3JVko': 'The company name on business license',
  'AyGOuG': 'Backstage sales screenshots of Amazon Germany, eBay Germany, Kaufland and other shops',
  'B4jhFM': 'E-mail for account registration',
  'BZ219V': 'Chinese name',
  'BgUDFC': 'Application status',
  'D6nMUK': 'Main products of the company',
  'DU8pzO': 'Company legal name',
  'DcPRut': 'The QQ number which you often use',
  'DhEqZS': 'Your WeChat account No.',
  'E92Gy6': 'Add new link',
  'EL4b8j': 'Links to "shops" of other e-commerce platforms',
  'EPp062': 'Name of the Germany company',
  'Ems0C9': 'Please fill in the name of service provider of your overseas warehouse',
  'EoXCE9': 'Business model',
  'F+ij7Y': 'Have you gone through the VAT of this German company',
  'FPYNcH': '请填写1到11位数字',
  'GzrOsm': 'The second category you applied:',
  'H26cpN': 'Note: set up the verification more than 20 words and less than 150 words.',
  'Hh+8lr': 'Note: Fill out the category of your current main products',
  'IcnW+V': 'The shop link of other North American e-commerce platforms',
  'InYzo7': 'Whether you plan to do the UK market or the Southeast Asian market',
  'Iv0cZc': 'Nationality of legal person',
  'JonMgV': 'SKU Quantity',
  'JzufF9': 'The QQ number which you often use',
  'KIfH+Q': 'Note: set up the verification more than 20 words and less than 150 words.',
  'KQOzSw': 'Email address',
  'KqTHNC': '库内截图',
  'L4jOeD': 'Note: Please fill in the specific main secondary category.',
  'LxjC12': 'QQ number',
  'MdKKAC': 'Links to "shops" of other e-commerce platforms',
  'NG02nv': 'The companys regions',
  'NuSU2V': 'Note (in Chinese)',
  'Nwgq9f': 'Do you have overseas warehouse in Germany',
  'OOfHj5': 'Name of legal person',
  'Ot/X5z': 'Check-in contact information',
  'P6ktCt': 'Note: fill out the Chinese name',
  'P8S+b1': 'Do you have German customer service staff',
  'R4mfIu': 'Note: for instance, Amazon Store / AliExpress Store / Tmall / JD.COM / Independent Station is preferred, or others',
  'SNeIpX': 'Note: Amazon Europe Station, Allegro, Fnac/darty, etc.',
  'U3/OiC': 'Links to other stores on European e-commerce platforms',
  'Uo35I9': '点击视频链接打开视频（只有已申请查询并获取视频的单据有库内视频信息，超期文件无法打开',
  'VFVI+w': 'Note: Fill out the concrete amount.',
  'VwT6Ym': 'Note: Fill out the concrete amount.',
  'WIRiiO': 'Main products (specific secondary category)',
  'WXHb1+': 'Please be sure to keep the phone open, which will be the main contact method in the future',
  'X+Zymb': 'Introduction of your company or listing the advantages of your company',
  'XEsuFF': 'Fill out the category of your current main products',
  'XXh7Kw': 'Note: Chinese name of business license',
  'XwN70f': 'Please fill in the links of Amazon Germany, eBay Germany, Kaufland, or shops/independent sites on other platforms',
  'Y0L01Z': 'Links to European and American cross-border e-commerce platforms in operation',
  'YI7fqG': 'Links to third-party platforms',
  'Z1d1dA': 'Your brand name on our platform',
  'ZcMSoa': 'Note: fill out the Chinese name',
  'aIq9ik': 'Sales of other North American e-commerce platforms (eBay, Amazon) with single site and single account in the past year(USD)',
  'aidSjp': '点击截图链接下载文件（只有已申请查询并获取视频的单据有库内截图信息，超期文件无法打开）',
  'bN8SdN': 'Profile of the brand/enterprise',
  'bNQ47y': 're-edit',
  'bilPnX': 'Main products of the company',
  'c9DIEs': 'Note: Fill in English or Pinyin example: Chinese-Zhang San or English-Rachel Green',
  'crZAUj': 'QQ number of the applicant',
  'csAYl3': 'Whether Weee exists or not exists must be filled in the category of electronic products',
  'd+drZB': 'Note: If any, please fill it out, and you will get the opportunity to connect the traffic-directing projects.',
  'fqBdzm': '公司法定名称',
  'gGYhmd': 'Name of the person who is in charge of the account',
  'gKaGa2': 'Description: Fill in the US station sales platform (whether there is Amazon/Walmart/independent station)',
  'gP+ldf': 'Check-in contact name',
  'gVUjRH': 'Note: Please keep the phone unimpeded',
  'gqZa18': 'Address of Chinese Company',
  'hC7WeL': 'Official website of the enterprise/brand',
  'i2HQKK': 'Inbound contact phone',
  'i8orsr': 'Sales',
  'iTutLd': 'The brand you own',
  'jJeioA': 'Legal person',
  'k0TWda': 'Independent station platform in use',
  'kUTW+Q': 'Applicants phone number',
  'l+0j0U': 'Sales of more than e-commerce platforms in the past 30 days',
  'lC0TIO': 'Fill in the specific amount',
  'lCo8xA': 'Note: Fill in more than 1 and less than 20 numbers',
  'm8yqtX': 'Please fill in the WeChat account',
  'mkiqo/': 'Name of Chinese company',
  'nVPQ6u': 'Website of independent station on Shopify',
  'nbGLjI': '库内视频',
  'oFGnIc': 'Business license of Chinese company{break}Business license of German company{break}A photo of the legal person holding his passport and ID card{break}Shipping proof local overseas warehouse in Germany{break}German certificate of German customer service staff/certificate of German native staff',
  'pKBw1k': '{platform} Application for admission',
  'pb7ufS': 'Email of the person who is in charge of the account',
  'pe5tUK': 'US station sales platform',
  'pnPqSu': 'Full name of the company',
  'q9+Dhh': 'Please fill in the registration email',
  'qDJlru': 'Average transaction value (USD)',
  'qDga7W': 'How long will it take for you to settle in: ',
  'qjVIUB': 'Please fill in the name of service provider of your overseas warehouse',
  's7Ufrr': 'Whether you have experience in live streaming/short video operation',
  'u1sMF4': '请提供证件并打包发送',
  'u6/UxW': 'Provide the following documents and upload them',
  'udZJ3q': 'Note: Fill in only numbers, no currency symbol required',
  'uqYkNh': 'Note: If you have never operated other platforms, please fill out "No" directly; if so, please fill out the concrete amount.',
  'v725h2': 'Please fill in the phone number',
  'v8b14F': 'Please fill in the name of the contact person',
  'vc/KMI': 'Move in now',
  'w+7yLR': 'Cross-border e-commerce sales in the past year(USD)',
  'w6hWi5': 'WeChat account of the person who is in charge of the account',
  'x6NFpn': 'Average transaction value (USD)',
  'xToKvz': 'TikTok account name (no, please fill in none)',
  'yMUv2D': 'Note: Fill in more than 1 and less than 60 characters',
  'q1fRx5': 'Backstage sales screenshots of Amazon Germany, eBay Ge rmany, Kaufland and other shops (important)',
  '+7V2pl': 'Total',
  '/1JAw2': 'English Product Name',
  '8970ZG': 'Winit Billing Product',
  '9SA/lA': 'Outbound Info',
  'GZcPC1': 'Back to Main Order',
  'QkwbXX': '(*The following time is based on the local time zone of the operation location)',
  'fD8+70': 'records',
  'fGrEYv': 'Recipient Email',
  'yF/N68': 'Verification code check failed',
};
